import './css/index.css';
import { number, exact, string, bool } from 'prop-types';
import React, { useCallback } from 'react';
import OverlayModal from 'components/overlay-modal/component';
import { render } from 'react-dom';

export default function InfoOverlay( props ) {

    const { text, heading, body, showInfoButtonOnly, offset } = props.data;
    const { overlayType } = props;

    const handleShow = useCallback( ( c ) => {

        renderOverlay( heading, body );


    } );

    const createOverlayWrapper = () => {

        const overlay = document.createElement( 'div' );

        overlay.className = `info-overlay${ overlayType ? ` ${ overlayType }` : '' }`;

        return document.body.insertAdjacentElement( 'beforeend', overlay );

    };

    const renderOverlay = ( heading, body ) => {


        const overlayWrapper = createOverlayWrapper();
        const refocus = document.querySelector( '.snippet-button' );

        const overlayMarkup = (
            <>
                <div
                    className='info-overlay-header'
                >
                    <h1>{ heading }</h1>
                </div>
                <div
                    className='info-overlay-body'
                >
                    <div className='info-overlay-section'>
                        <div dangerouslySetInnerHTML={{ __html: body }}></div>
                    </div>
                </div>

            </>
        );

        render(
            <OverlayModal
                isOpen={ true }
                wrapper={ overlayWrapper }
                refocusElement={ refocus }
                overlayMarkup={ overlayMarkup }
                className='info-overlay-content-md'
            />,
            overlayWrapper
        );

    };


    return (
        <button type='button' className={ `info-button icon-info-utility ${ offset ? 'btn-offset' : '' } ${ !showInfoButtonOnly ? 'in-body-text' : '' }` } onClick={ handleShow }>

            <span className='info-button-text'>{ !showInfoButtonOnly && text }</span>

        </button>

    );

}

InfoOverlay.propTypes = {
    data: exact( { text: string, heading: string, body: string, showInfoButtonOnly: bool, offset: bool } ),
    overlayType: string,
    id: number
};
